import _ from 'lodash';

const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

function compareValues(a, b) {
  if (a === b || (a == null && b == null)) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  if (typeof a === 'string' && typeof b === 'string') return collator.compare(a, b);
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

// _.sortBy can't take a comparator; Intl.Collator ignores case and accents and sorts numbers by value.
function sortAlphabetically(collection, iteratees) {
  const getters = _.castArray(iteratees).map(_.iteratee);
  return _.toArray(collection).sort((a, b) => {
    for (const get of getters) {
      const result = compareValues(get(a), get(b));
      if (result) return result;
    }
    return 0;
  });
}
export default sortAlphabetically;
